// extracted by mini-css-extract-plugin
export default {"container":"AuthorizedLayout_container__IiaCn"};